
<script>
import { required } from "vuelidate/lib/validators";
import Repositories from "@/repositories";
const repository = Repositories.get("projectmanagers");

export default {
  components: {},
  data() {
    return {
      showModal: false,
      title: "Edit Project Manager",
      form: {
        name: null,
        id: null,
      },
      isFormSubmit: false,
      resolvePromise: null,
      rejectPromise: null,
    };
  },
  created() {},
  beforeDestroy() {},
  computed: {},
  methods: {
    showEdit: function (entity) {
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
        this.form = entity;
        this.showModal = true;
      });
    },
    closeModal() {
      this.showModal = false;
      this.isFormSubmit = false;
      this.form = {
        id: null,
        name: null,
      };
    },
    formSubmit() {
      this.isFormSubmit = true;
      this.$v.form.$touch();

      if (!this.$v.form.$invalid) {
        //save form
        repository.update(
          this.form,
          this.form.id
        ).then((response) => {
          this.resolvePromise(response.data);
          this.closeModal();
        });
      }
    },
  },
  validations: {
    form: {
      name: { required },
    },
  },
};
</script>

<template>
  <b-modal
    v-model="showModal"
    :title="$t('general.editProjectManager')"
    title-class="text-black font-18"
    hide-footer
    body-class="p-3"
    size="sm"
  >
    <b-form @submit.prevent="formSubmit">
      <div class="row">
        <b-form-group style="position: relative" class="col-12">
          <label>{{ $t("general.name") }}</label>
          <b-form-input
            v-model="form.name"
            :class="{
              'is-invalid':
                isFormSubmit && $v.form.name.$error,
            }"
            :placeholder="$t('general.name')"
          >
          </b-form-input>
          <div
            v-if="isFormSubmit && $v.form.name.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.name.required">{{
              $t("general.valueRequired")
            }}</span>
          </div>
        </b-form-group>
      </div>
      <div class="text-right pt-3">
        <b-button variant="light" @click="closeModal">{{
          $t("general.close")
        }}</b-button>
        <b-button type="submit" class="ml-1" variant="success">{{
          $t("general.save")
        }}</b-button>
      </div>
    </b-form>
  </b-modal>
</template>